var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvcIdle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3333 3.66667L7.425 14.575M13.2917 13.2917L18.3333 18.3333M7.425 7.425L11 11M5.5 8.25C6.22935 8.25 6.92882 7.96027 7.44454 7.44454C7.96027 6.92882 8.25 6.22935 8.25 5.5C8.25 4.77065 7.96027 4.07118 7.44454 3.55546C6.92882 3.03973 6.22935 2.75 5.5 2.75C4.77065 2.75 4.07118 3.03973 3.55546 3.55546C3.03973 4.07118 2.75 4.77065 2.75 5.5C2.75 6.22935 3.03973 6.92882 3.55546 7.44454C4.07118 7.96027 4.77065 8.25 5.5 8.25ZM5.5 19.25C6.22935 19.25 6.92882 18.9603 7.44454 18.4445C7.96027 17.9288 8.25 17.2293 8.25 16.5C8.25 15.7707 7.96027 15.0712 7.44454 14.5555C6.92882 14.0397 6.22935 13.75 5.5 13.75C4.77065 13.75 4.07118 14.0397 3.55546 14.5555C3.03973 15.0712 2.75 15.7707 2.75 16.5C2.75 17.2293 3.03973 17.9288 3.55546 18.4445C4.07118 18.9603 4.77065 19.25 5.5 19.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvcIdle);
export default __webpack_public_path__ + "static/media/svc-idle.2f95c13181086a78036d282c1b000baa.svg";
export { ForwardRef as ReactComponent };